import createConverter from './lib/create_converter';
import DiagnosticsConfig from 'models/diagnostics_config';

export default createConverter(DiagnosticsConfig);
